// extracted by mini-css-extract-plugin
module.exports = {"baseSectionTitleJtails":"BaseSectionTitleJtails_baseSectionTitleJtails_1o5Zr","isStyleDingBeauty":"BaseSectionTitleJtails_isStyleDingBeauty_3_xAW"};